import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'view-invig',
  templateUrl: './view-invig.component.html',
  styleUrls: ['./view-invig.component.scss']
})
export class ViewInvigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
